import { render, staticRenderFns } from "./NotNew.vue?vue&type=template&id=0f52911a"
import script from "./NotNew.vue?vue&type=script&lang=js"
export * from "./NotNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports